import { render, staticRenderFns } from "./tracking-progress.vue?vue&type=template&id=a510064e&scoped=true&"
import script from "./tracking-progress.vue?vue&type=script&lang=js&"
export * from "./tracking-progress.vue?vue&type=script&lang=js&"
import style0 from "./tracking-progress.vue?vue&type=style&index=0&id=a510064e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a510064e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzIconCheck: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-check/index.js').default,RzIconCircle: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-circle/index.js').default,RzIconWarningTriangle: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-warning-triangle/index.js').default})
